import { get } from 'axios'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function getProgramSeasonParticipantParticipantDocuments (pIdProgramSeasonParticipant) {
    const URI = `${BASE_URL}/api/programSeasonParticipants/${pIdProgramSeasonParticipant}/participantDocuments`
    return get(URI, { headers })
}
export { getProgramSeasonParticipantParticipantDocuments }